module.exports = __webpack_public_path__ + "static/media/textW2PIntegrated.05be6a60.md";